<template>
  <Modal
    title="Cadastrar nova ocorrência"
    :active.sync="active"
    @close="closeModal"
  >
    <FormOccurrence
      :entityId="entityId"
      :saveOccurrenceApi="saveOccurrenceApi"
      @update="closeModal"
    />
  </Modal>
</template>
<script>
import Modal from '../../components/Modal.vue';
import 'quill/dist/quill.snow.css';
import FormOccurrence from '../forms/FormOccurrence.vue';

export default {
  name: 'ModalCadastroOcorrencias',
  props: ['entityId', 'saveOccurrenceApi', 'occurrences'],
  components: { Modal, FormOccurrence },
  data() {
    return {
      active: false,
    };
  },
  methods: {
    openModal() {
      this.active = true;
    },
    closeModal() {
      this.active = false;
      this.$emit('close');
    },
  },
};
</script>
<style scoped></style>
